// src/components/ServerDatabase/ServerSearchCapsule.jsx
import React, { useRef } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const ServerSearchCapsule = ({ searchQuery, onSearchChange, onClearSearch }) => {
  const { language } = useLanguage();
  const isEn = language === 'en';
  const inputRef = useRef(null);

  const handleClear = () => {
    onClearSearch();
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <section className="sdb-search-hero-box">
      <div className="sdb-search-input-capsule">
        <div className="sdb-search-icon-badge">
          <svg viewBox="0 0 24 24" fill="none">
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
        </div>

        <input
          ref={inputRef}
          type="text"
          className="sdb-search-text-field"
          placeholder={
            isEn
              ? 'Search by address, version, core (e.g. hypixel.net, 1.16.5, Paper)...'
              : 'Поиск по адресу, версии, ядру (например, hypixel.net, 1.16.5, Paper)...'
          }
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          autoComplete="off"
          spellCheck="false"
        />

        <button
          type="button"
          className={`sdb-search-clear-btn ${searchQuery ? 'visible' : ''}`}
          onClick={handleClear}
          title={isEn ? 'Clear search' : 'Очистить поиск'}
        >
          <svg viewBox="0 0 24 24">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
    </section>
  );
};

export default ServerSearchCapsule;
